import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "wage-premium-collapse" }
const _hoisted_2 = ["aria-expanded"]
const _hoisted_3 = { class: "wage-payroll-grid__label wage-premium-collapse__label" }
const _hoisted_4 = ["checked", "disabled"]
const _hoisted_5 = { class: "wage-premium-collapse__value" }
const _hoisted_6 = { class: "wage-premium-collapse__sum" }
const _hoisted_7 = { class: "wage-premium-collapse__body" }

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'HomeWagePremiumCollapse',
  props: {
    expanded: { type: Boolean },
    sum: {},
    formatSum: {},
    showManualToggle: { type: Boolean },
    manualAdjustEnabled: { type: Boolean },
    manualToggleDisabled: { type: Boolean },
    label: { default: '연장야간휴일' }
  },
  emits: ["update:expanded", "update:manualAdjustEnabled"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const onManualToggle = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked;
  emit('update:manualAdjustEnabled', checked);
};

const sumDisplay = computed(() => {
  if (props.sum <= 0) return '';
  return props.formatSum(props.sum);
});

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      type: "button",
      class: _normalizeClass(["wage-premium-collapse__row", { 'wage-premium-collapse__row--with-fix': __props.showManualToggle }]),
      "aria-expanded": __props.expanded,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('update:expanded', !__props.expanded)))
    }, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(__props.label), 1),
      (__props.showManualToggle)
        ? (_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "checkbox",
            class: "wage-insurance-single__fix-cb",
            checked: __props.manualAdjustEnabled,
            disabled: __props.manualToggleDisabled,
            onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (onManualToggle($event)))
          }, null, 40, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("span", _hoisted_5, [
        _createElementVNode("span", _hoisted_6, _toDisplayString(sumDisplay.value), 1),
        _createVNode(_component_v_icon, {
          size: "12",
          class: "wage-premium-collapse__chevron"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.expanded ? 'mdi-chevron-down' : 'mdi-chevron-right'), 1)
          ]),
          _: 1
        })
      ])
    ], 10, _hoisted_2),
    _withDirectives(_createElementVNode("div", _hoisted_7, [
      _renderSlot(_ctx.$slots, "default")
    ], 512), [
      [_vShow, __props.expanded]
    ])
  ]))
}
}

})